<template>
	<article 
		:id="id" 
		:class="[labelClass, 'dc-post-grid-card', 'nansen-card']"
		v-on:click.stop.prevent="goToPost()"
	>
		<div class="card-inner">
			<div ref="cardContentWrapper" class="card-inner__content-wrapper">
				<div class="card-inner__text-wrapper">
					<div>
						<div class="card-inner__text-wrapper__terms-wrapper">
							<div v-for="(term, i) in terms" v-html="term" :key="i"></div>
						</div>
						<h1 v-if="title" class="card-title">{{ title }}</h1>
						<p v-if="excerpt" class="card-excerpt" v-html="excerpt"></p>
					</div>

					<a ref="postLink" v-if="url" :href="url" class="link read-more-link">{{ dctxt('lesMerAlt') }}</a>
				</div>


				<div class="card-inner__image-wrapper">
					<img v-if="image" :src="image.src" :alt="image.alt" :srcset="image.srcset" />
				</div>
			</div>
		</div>
	</article>
</template>

<script>
import {Translatable} from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [
		Translatable
	],
	props: {
		id: {
			type: String|Number,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		url: {
			type: String,
			required: true
		},
		excerpt: {
			type: String,
			required: false
		},
		label: {
			type: Object,
			required: false
		},
		image: {
			type: Object,
			required: false,
		},
		terms: {
			type: Array,
			required: false
		},
	},
	computed: {
		labelClass() {
			if (typeof this.label === 'undefined' || typeof this.label.class === 'undefined') return '';
			return this.label.class;
		}
	},
	methods: {
		goToPost() {
			window.location.href = this.url
		}
	}
}
</script>

